/**
 * Construct URL for uploaded images (events, news, etc.)
 * In development: use full backend URL to avoid proxy issues with static files.
 * In production: use relative path for reverse proxy.
 */
const BACKEND_BASE = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_API_URL || 'http://localhost:5010');

export const getImageUrl = (imagePath: string | undefined): string | null => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) return imagePath;
  let finalPath = imagePath.trim();
  if (!finalPath.startsWith('/uploads')) {
    finalPath = finalPath.replace(/^\/+/, '');
    finalPath = `/uploads/${finalPath}`;
  }
  finalPath = finalPath.replace(/([^:]\/)\/+/g, '$1');
  return `${BACKEND_BASE}${finalPath}`;
};
